module.exports = __webpack_public_path__ + "static/img/kr.c8dc907.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/footer/img/footer_icon/kr.png
// module id = NjNO
// module chunks = 0